// Where a credential came from (Person.Credential.Origin); mirrors the App Server's constants/credentialOrigin.js.
// BLUETOOTH: the app wrote it to the lock over BLE (lock-first), so only the app can remove it.
export const CREDENTIAL_ORIGIN = {
	PHYSICAL: 'PHYSICAL',
	VIRTUAL: 'VIRTUAL',
	BLUETOOTH: 'BLUETOOTH'
};
